import cn from 'classnames';
import parse from 'html-react-parser';
import SVG from 'react-inlinesvg';
import ImageComponent from '../../../Image/Image';
import styles from './Card.module.scss';
import { useAppContext } from '../../../../context/appContext';

export const Card = ({ image, title, description, footnote, link, modal, linkIcon, isForDarkSection, minHeight = null }) => {
    const { updateAppData } = useAppContext();

    const handlerClick = (event) => {
        event.preventDefault();
        
        if(modal && modal.id) {
            updateAppData({
                sliderModal: modal
            })
        }

        if(link) window.open(link, '_blank');

    }

    return (
        <div
            className={ cn(
                styles.card, {
                    [styles.isForDarkSection]: isForDarkSection,
                    [styles['minHeight'+minHeight]]: minHeight,
                    [styles.hover]: link || modal || linkIcon,
                    [styles.hoverIcon]: linkIcon
                }
            ) }
            onClick={ handlerClick }
        >
            <div className={ styles.image }>
                <ImageComponent src={ image } />
            </div>
            <div className={ styles.content }>
                { (title || description) && (
                    <div className={ styles.text }>
                        { title && (
                            <h3 className={ styles.title }>{ parse(title) }</h3>
                        ) }
                        { description && (
                            <p className={ styles.description }>{ parse(description) }</p>
                        ) }
                    </div>
                ) }
                <div className={ styles.bottom }>
                    { footnote && (
                        <p className={ styles.footnote }>{ parse(footnote) }</p>
                    ) }
                    { linkIcon && (
                        <div className={ styles.icon }>
                            <SVG src={ `/img/icons/icon-link-${linkIcon}.svg` } />
                        </div>
                    ) }
                </div>
            </div>
        </div>
    )
}
